import React from 'react';
import IconNext from '@/assets/IconRight.svg';
import IconPrev from '@/assets/IconLeft.svg';

import { IButtonsSliderProps } from './interface';

export const ButtonsSlider = ({
  handleClick,
  sliderScroll,
  checkScrollLimit,
}: IButtonsSliderProps) => {
  return (
    <div className="vitrine-template1__cards-buttons">
      <button
        type="button"
        onClick={() => handleClick('left')}
        disabled={sliderScroll <= 0}
        className="vitrine-template1__cards-buttons--left"
        data-testid="prev"
      >
        <img src={IconPrev} alt="Anterior" />
      </button>

      <button
        type="button"
        onClick={() => handleClick('right')}
        disabled={checkScrollLimit()}
        className="vitrine-template1__cards-buttons--right"
        data-testid="next"
      >
        <img src={IconNext} alt="Próximo" />
      </button>
    </div>
  );
};
